import React from 'react';
import { Box, Button, Container, Divider, Grid, Typography, Link, SvgIcon } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DescriptionIcon from '@mui/icons-material/Description';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import './howItWorks.css';

const HowItWorks: React.FC = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  return (
    <div className='how-container'>
      <h1>How It Works</h1>
      <p className='subtitle'>
        Your Safety Is Our Priority. Here's How SAëF Ensures a Secure and Seamless Experience.
      </p>
      <section className='how-section'>
        <h2>Step 1: Book Now</h2>
        <p className='how-description'>
          Click the “Book Now” button to initiate your personalized protection and concierge
          experience. Whether you need immediate deployment or are planning ahead, it only takes a
          moment to get started.
        </p>
        <ul className='how-list'>
          <li>Quick online access</li>
          <li>24/7 availability</li>
        </ul>
      </section>
      <section className='how-section'>
        <h2>Step 2: Order Form</h2>
        <p className='how-description'>
          Complete our secure order form by providing details about your stay in Las Vegas. Choose
          from a range of premium services including:
        </p>
        <ul className='how-list'>
          <li>Executive Protection</li>
          <li>Secure Transportation (Sedans, SUVs, Armored Options)</li>
          <li>Event & Venue Security</li>
          <li>24/7 Lifestyle Concierge</li>
        </ul>
        <ul className='how-list'>
          <li>Fully tailored to your travel, event, or lifestyle needs</li>
          <li>All information remains confidential</li>
        </ul>
      </section>
      <section className='how-section'>
        <h2>Step 3: Payment</h2>
        <p className='how-description'>
          Enter your payment information through our encrypted checkout system. All transactions are
          protected to ensure your data remains private and secure.
        </p>
        <ul className='how-list'>
          <li>Major credit cards accepted</li>
          <li>Transparent pricing</li>
          <li>Instant confirmation</li>
        </ul>
      </section>
      <section className='how-section'>
        <h2>Step 4: Follow-Up & Confirmation</h2>
        <p className='how-description'>
          A dedicated SAëF Operations Specialist will contact you directly to:
        </p>
        <ul className='how-list'>
          <li>Confirm your identity</li>
          <li>Review arrival times and logistics</li>
          <li>Finalize service preferences</li>
          <li>Ensure all security measures are in place</li>
        </ul>
        <p className='how-description'>
          You’ll receive your final itinerary, assigned personnel details (if applicable), and a
          24/7 direct contact line.
        </p>
      </section>
      <section className='how-section'>
        <h2>Experience Las Vegas with Confidence</h2>
        <p className='how-description'>
          With SAëF, luxury and protection go hand-in-hand. Discreet. Dependable. Designed around
          you.
        </p>
        <p className='how-description'>
          Your safety is never left to chance. Click below to begin.
        </p>
      </section>
      <Box display='flex' justifyContent='center' mt={4}>
        <Button
          variant='contained'
          size='large'
          sx={{
            borderRadius: '999px',
            backgroundColor: '#1993e5',
            textTransform: 'none',
            fontWeight: 700,
            px: 5,
            '&:hover': { backgroundColor: '#1781cc' },
          }}
          onClick={() =>
            isAuthenticated ? navigate('/new-order/1/Essential%20Protection') : login()
          }
        >
          Book Now
        </Button>
      </Box>
      ;
    </div>
  );
};

export default HowItWorks;
